import { useMemo } from "react";

import { Card, CardBody, Input } from "reactstrap";

import { TableSearchInput } from "@atoms";

const commonClassName =
  "btn-w text-light table__search table__search-input mb-0";

const AccountsTableSearch = ({ form, setSubmitSearch }) => {
  const { control, watch, setValue } = form;
  const { searchInput } = watch();

  const handleClear = (e) => {
    e.preventDefault();
    setSubmitSearch(true);
    setValue("searchInput", "");
  };

  const handleClick = () => {
    setSubmitSearch(true);
  };

  const buttonProps = useMemo(
    () => [
      {
        type: "submit",
        className: `btn-blue ${commonClassName}`,
        value: "Filter",
        onClick: handleClick,
      },
      ...(searchInput
        ? [
            {
              type: "reset",
              className: commonClassName,
              value: "Clear",
              onClick: handleClear,
            },
          ]
        : []),
    ],
    [searchInput]
  );

  return (
    <Card className="pb-2">
      <CardBody className="py-2 px-0 table__search mb-0">
        <TableSearchInput
          name="searchInput"
          control={control}
          className="w-100"
          maxLength={50}
          placeholder="First, Last, SS4, Account # or Policy #"
        />
        {buttonProps?.map((props) => (
          <Input key={props?.value} {...props} />
        ))}
      </CardBody>
    </Card>
  );
};

export default AccountsTableSearch;
